import React, { Component } from "react";
import { Grid, Table } from "tabler-react";
import { Crud_Catalogos } from '../../../../herramientas/Crud_Catalogos';
import ReactToPrint from 'react-to-print';
import L from "leaflet";
import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import axios from 'axios';
import { api_raiz } from '../../../../config/config';

class BitacoraPdf extends Component {
  constructor(props) {
    super(props);

    this.state = {
      trackPoints: [],
      incidencias: [],
      distancia: 0,
      patio: {},
      movlogs: {},
      tiempoEntrePulsos: 0,
      detencionesCalculadas: [],
      imagesMovGps: [],
      loading: true
    };

    this.tiempoRuta = 0;
    this.estadia = 0;
    this.avgLat = 0;
    this.avgLon = 0;
    this.coordenadas = [];
    this.distanciaCalculada = 0;

    this.componentRef = React.createRef();
  }

  componentDidMount() {
    this.loadData();
  }

  async loadData() {
    const { Movimiento } = this.props;
    
    try {
      // Cargar datos en paralelo
      const [trackPoints, distancia, patio, incidencias, movlogs] = await Promise.all([
        this.loadTrackPoints(Movimiento.id),
        this.loadDistancia(Movimiento.id),
        this.loadPatio(Movimiento.id),
        this.loadIncidencias(Movimiento.id),
        this.loadMovlogs(Movimiento.id)
      ]);

      this.setState({
        trackPoints,
        distancia,
        patio,
        incidencias,
        movlogs,
        loading: false
      });

      // Cargar imágenes después de obtener los datos principales
      await this.loadImages(Movimiento.id);
      
    } catch (error) {
      console.error("Error cargando datos:", error);
      this.setState({ loading: false });
    }
  }

  async loadTrackPoints(movimientoId) {
        const { Movimiento } = this.props;

    try {
      let trackPoints = await Crud_Catalogos(`navieraMovimientos/tracks/${movimientoId}`, "", "get", "", [], "", "", "", []);
      
      // Si no hay suficientes puntos, intentar con esFull
      if (trackPoints && trackPoints.length < 3 && this.state.patio?.esFull) {
        trackPoints = await Crud_Catalogos(`navieraMovimientos/tracks/${this.state.patio.esFull}`, "", "get", "", [], "", "", "", []);
      }
      if(Movimiento.idMovimientoTipo.id===1||Movimiento.idMovimientoTipo.id===336) {
            console.log("importamiento");

            // Filter trackpoints based on UTC time
            // Convert local times to UTC for comparison
            if (trackPoints && trackPoints.length > 0 && Movimiento.salidaClienteLleno && Movimiento.arriboTerminalCargado) {
              // Convert local times to Date objects
              const salidaClienteLlenoLocal = new Date(Movimiento.salidaClienteLleno);
              const arriboTerminalCargadoLocal = new Date(Movimiento.arriboTerminalCargado);
              
              // Convert local dates to UTC (add 6 hours)
              const salidaClienteLlenoUTC = new Date(salidaClienteLlenoLocal.getTime() + (6 * 60 * 60 * 1000));
              const arriboTerminalCargadoUTC = new Date(arriboTerminalCargadoLocal.getTime() + (6 * 60 * 60 * 1000));
              
              // Filter trackpoints within the time range
              trackPoints = trackPoints.filter(point => {
                if (!point.utc) return false;
                const pointDate = new Date(point.utc);
                
                return pointDate >= salidaClienteLlenoUTC && pointDate <= arriboTerminalCargadoUTC;
              });
            }
            return trackPoints || [];
      }


      if( Movimiento.idMovimientoTipo.id===2) {
         console.log("exportamiento 1");
         // Filter trackpoints based on UTC time
         // Convert local times to UTC for comparison
        //  if ( trackPoints &&  trackPoints.length > 0 && Movimiento.inicioRuta  && this.state.movlogs?.salidaTerminalLleno) {
        //            console.log("exportamiento 2");

        //    // Convert local times to Date objects
        //    const inicioRutaLocal = new Date(Movimiento.inicioRuta);
        //    const salidaTerminalLlenoLocal = new Date(this.state.movlogs.salidaTerminalLleno);
        //    // Convert local dates to UTC (add 6 hours)
        //    const inicioRutaUTC = new Date(inicioRutaLocal.getTime() + (6 * 60 * 60 * 1000));
        //    const salidaTerminalLlenoUTC = new Date(salidaTerminalLlenoLocal.getTime() + (6 * 60 * 60 * 1000));
        //    // Filter trackpoints within the time range
        //    trackPoints = trackPoints.filter(point => {
        //     if (!point.utc) return false;
        //      const pointDate = new Date(point.utc);        
        //      return pointDate >= inicioRutaUTC && pointDate <= salidaTerminalLlenoUTC;
             
        //    });
        //  }


         if ( trackPoints &&  trackPoints.length > 0 && Movimiento.salidaClienteLleno  && Movimiento.arriboTerminalCargado) {
                   console.log("exportamiento 2");
           const inicioRutaLocal = new Date(Movimiento.salidaClienteLleno);
           const salidaTerminalLlenoLocal = new Date(Movimiento.arriboTerminalCargado);
           const inicioRutaUTC = new Date(inicioRutaLocal.getTime() );
           const salidaTerminalLlenoUTC = new Date(salidaTerminalLlenoLocal.getTime() );
           trackPoints = trackPoints.filter(point => {
            if (!point.utc) return false;
             const pointDate = new Date(point.utc);        
             return pointDate >= inicioRutaUTC && pointDate <= salidaTerminalLlenoUTC;
             
           });
         }


         return trackPoints || [];
      }



    } catch (error) {
      console.error("Error cargando track points:", error);
      return [];
    }
  }

  async loadDistancia(movimientoId) {
    try {
      return await Crud_Catalogos(`distanciaRecorridaView/distanciaRecorrida/${movimientoId}`, "", "get", "", [], "", "", "", []);
    } catch (error) {
      console.error("Error cargando distancia:", error);
      return 0;
    }
  }

  async loadPatio(movimientoId) {
    try {
      return await Crud_Catalogos(`movimientosPatio/idMovimiento/${movimientoId}`, "", "get", "", [], "", "", "", []);
    } catch (error) {
      console.error("Error cargando patio:", error);
      return {};
    }
  }

  async loadIncidencias(movimientoId) {
    try {
      return await Crud_Catalogos(`movimientoIncidencias/movimiento/${movimientoId}`, "", "get", "", [], "", "", "", []);
    } catch (error) {
      console.error("Error cargando incidencias:", error);
      return [];
    }
  }

  async loadMovlogs(movimientoId) {
    try {
      return await Crud_Catalogos(`navieraMovimientos/${movimientoId}`, "", "get", "", [], "", "", "", []);
    } catch (error) {
      console.error("Error cargando movlogs:", error);
      return {};
    }
  }

  async loadImages(movimientoId) {
    try {
      const instance = axios.create({
        headers: {
          Authorization: 'Bearer ' + sessionStorage.getItem('tok'),
        },
      });

      const response = await instance.get(`${api_raiz}movimientoGps/movimiento/${movimientoId}`);
      
      if (response.data && response.data.length > 0) {
        const movGpsId = response.data[0].id;
        const imagesResponse = await instance.get(`${api_raiz}getImagesMovGps/${movGpsId}/asignacion`);
        
        if (imagesResponse.data && imagesResponse.data.length > 0) {
          this.setState({ imagesMovGps: imagesResponse.data });
        }
      }
    } catch (error) {
      console.error("Error cargando imágenes:", error);
    }
  }

  // Función para calcular la distancia entre dos puntos usando Haversine
  calcularDistanciaEntrePuntos(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radio de la Tierra en km
    const dLat = this.deg2rad(lat2 - lat1);
    const dLon = this.deg2rad(lon2 - lon1);
    const a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * 
      Math.sin(dLon/2) * Math.sin(dLon/2); 
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
    return R * c;
  }

  deg2rad(deg) {
    return deg * (Math.PI/180);
  }

  calcularDetenciones(coordenadas, tiempoEntrePulsos) {
    if (!coordenadas || coordenadas.length < 2 || !tiempoEntrePulsos) {
      return [];
    }

    const detenciones = [];
    const UMBRAL_DISTANCIA = 0.05; // 50 metros
    const UMBRAL_TIEMPO_MINUTOS = 15;
    const PULSOS_PARA_DETENCION = Math.ceil(UMBRAL_TIEMPO_MINUTOS / tiempoEntrePulsos);

    let contadorPulsosSinMovimiento = 0;
    let inicioDetencionIndex = null;

    for (let i = 1; i < coordenadas.length; i++) {
      const puntoActual = coordenadas[i];
      const puntoAnterior = coordenadas[i - 1];

      const distancia = this.calcularDistanciaEntrePuntos(
        puntoActual[0], puntoActual[1],
        puntoAnterior[0], puntoAnterior[1]
      );

      if (distancia < UMBRAL_DISTANCIA) {
        if (contadorPulsosSinMovimiento === 0) {
          inicioDetencionIndex = i - 1;
        }
        contadorPulsosSinMovimiento++;
      } else {
        if (contadorPulsosSinMovimiento >= PULSOS_PARA_DETENCION && inicioDetencionIndex !== null) {
          const finDetencionIndex = i - 1;
          const duracion = contadorPulsosSinMovimiento * tiempoEntrePulsos;

          detenciones.push({
            inicioPulso: inicioDetencionIndex,
            finPulso: finDetencionIndex,
            inicio: inicioDetencionIndex * tiempoEntrePulsos,
            fin: finDetencionIndex * tiempoEntrePulsos,
            duracion: duracion,
            latitud: coordenadas[inicioDetencionIndex][0],
            longitud: coordenadas[inicioDetencionIndex][1]
          });
        }

        contadorPulsosSinMovimiento = 0;
        inicioDetencionIndex = null;
      }
    }

    // Verificar detención al final
    if (contadorPulsosSinMovimiento >= PULSOS_PARA_DETENCION && inicioDetencionIndex !== null) {
      const finDetencionIndex = coordenadas.length - 1;
      const duracion = contadorPulsosSinMovimiento * tiempoEntrePulsos;

      detenciones.push({
        inicioPulso: inicioDetencionIndex,
        finPulso: finDetencionIndex,
        inicio: inicioDetencionIndex * tiempoEntrePulsos,
        fin: finDetencionIndex * tiempoEntrePulsos,
        duracion: duracion,
        latitud: coordenadas[inicioDetencionIndex][0],
        longitud: coordenadas[inicioDetencionIndex][1]
      });
    }

    return detenciones;
  }

  calcularTiempos() {
    const { Movimiento } = this.props;
    const tipoMovimiento = Movimiento.idMovimientoTipo.id;

    let tiempoRuta = 0;
    let estadia = 0;

    if (tipoMovimiento === 1| tipoMovimiento === 336) {
      const inicioRuta = new Date(Movimiento.inicioRuta);
      const arriboClienteLleno = new Date(Movimiento.arriboClienteLleno);
      const salidaClienteVacio = new Date(Movimiento.salidaClienteVacio);
      
      tiempoRuta = arriboClienteLleno - inicioRuta;
      estadia = salidaClienteVacio - arriboClienteLleno;
    } else if (tipoMovimiento === 2) {
      const arriboClienteVacio = new Date(Movimiento.arriboClienteVacio);
      const salidaClienteLleno = new Date(Movimiento.salidaClienteLleno);
      const arriboTerminalCargado = new Date(Movimiento.arriboTerminalCargado);
      
      estadia = salidaClienteLleno - arriboClienteVacio;
      tiempoRuta = Math.abs(salidaClienteLleno - arriboTerminalCargado);
    }

    return {
      tiempoRuta: Math.abs(tiempoRuta) > 1600000000000 ? 0 : (tiempoRuta / (1000 * 3600)).toFixed(2),
      estadia: Math.abs(estadia) > 1600000000000 ? 0 : (estadia / (1000 * 3600)).toFixed(2)
    };
  }

  procesarCoordenadas() {
    const coordenadas = [];
    let avgLat = 0;
    let avgLon = 0;

    if (!this.state.trackPoints) {
      return { coordenadas: [], avgLat: 0, avgLon: 0 };
    }

    this.state.trackPoints.forEach(punto => {
      if (punto.position && punto.position.latitude && punto.position.longitude) {
        avgLat += punto.position.latitude;
        avgLon += punto.position.longitude;
        coordenadas.push([punto.position.latitude, punto.position.longitude]);
      }
    });

    if (coordenadas.length > 0) {
      avgLat = avgLat / coordenadas.length;
      avgLon = avgLon / coordenadas.length;
    }

    return { coordenadas, avgLat, avgLon };
  }

  calcularDistanciaTotal(coordenadas) {
    let distanciaTotal = 0;
    
    for (let i = 0; i < coordenadas.length - 1; i++) {
      const [lat1, lon1] = coordenadas[i];
      const [lat2, lon2] = coordenadas[i + 1];
      
      if (lat1 && lon1 && lat2 && lon2) {
        distanciaTotal += this.calcularDistanciaEntrePuntos(lat1, lon1, lat2, lon2);
      }
    }
    
    return distanciaTotal;
  }

  formatearFecha(fecha) {
    const date = new Date(fecha);
    return `${date.getDate()} de ${date.toLocaleDateString('es-ES', { month: 'long' })}`;
  }

  renderHeader() {
    const hoy = new Date();
    return (
      <>
        <img src="images/head.png" alt="Header" />
        <br /><br /><br />
        <Grid.Col>
          <h2 align="right">
            Ciudad de México a {this.formatearFecha(hoy)} de {hoy.getFullYear()}&nbsp;&nbsp;&nbsp;&nbsp;
          </h2>
          <br /><br />
        </Grid.Col>
      </>
    );
  }

  renderInfoBasica() {
    const { Movimiento } = this.props;
    const { patio } = this.state;

    return (
      <div>
        &nbsp;&nbsp;&nbsp; Servicio:<b>{Movimiento.idCliente.nombreCorto}</b>
        <p>&nbsp;&nbsp;&nbsp; Sky Angel </p>
        <br /><br />
        
        <Table>
          <Table.Body>
            <Table.Row>
              <Table.Col><b>Solicitó:</b>&nbsp;&nbsp;{Movimiento.idTransportista.contactoNombre || "No Disponible"}</Table.Col>
              <Table.Col><b>Solicitado:</b>&nbsp;&nbsp;{this.formatearFecha(Movimiento.creationDate)}</Table.Col>
              <Table.Col><b>Colocado:</b>&nbsp;&nbsp;{this.formatearFecha(Movimiento.citaProgramada)}</Table.Col>
            </Table.Row>
          </Table.Body>
        </Table>

        <Table>
          <Table.Body>
            <Table.Row>
              <Table.Col>
                <br/><br/><br/>
                <Table>
                  <Table.Body>
                    <Table.Row>
                      <Table.Col><b>Transporte:</b></Table.Col>
                      <Table.Col>{Movimiento.idTransportista.nombre}</Table.Col>
                    </Table.Row>
                    <Table.Row>
                      <Table.Col><b>Booking:</b></Table.Col>
                      <Table.Col>{Movimiento.booking}</Table.Col>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </Table.Col>
              
              <Table.Col>
                <br/><br/><br/>
                <Table>
                  <Table.Body>
                    <Table.Row>
                      <Table.Col><b>Unidad:</b> {patio.tractorPlaca}</Table.Col>
                    </Table.Row>
                    <Table.Row>
                      <Table.Col><b>Remolque:</b> {patio.remolquePlaca}</Table.Col>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </Table.Col>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    );
  }

  renderDetallesMovimiento(tiempos, coordenadas, distanciaTotal) {
    const { Movimiento } = this.props;
    const { movlogs, detencionesCalculadas, distancia } = this.state;

    return (
      <Table>
        <Table.Body>
          <Table.Row>
            <Table.Col><b>Origen:</b></Table.Col>
            <Table.Col>{Movimiento.idCorredor.nombre}</Table.Col>
            <Table.Col><b>Destino:</b></Table.Col>
            <Table.Col>{Movimiento.destino}</Table.Col>
          </Table.Row>

          {/* Campos específicos para exportaciones */}
          {Movimiento.idMovimientoTipo.id === 1 && (
            <>
              <Table.Row>
                <Table.Col><b>Inicio de Ruta:</b></Table.Col>
                <Table.Col>{Movimiento.inicioRuta}</Table.Col>
                <Table.Col></Table.Col>
                <Table.Col></Table.Col>
              </Table.Row>
              <Table.Row>
                <Table.Col><b>Salida de terminal con contenedor cargado:</b></Table.Col>
                <Table.Col>{movlogs.salidaTerminalLleno}</Table.Col>
                <Table.Col></Table.Col>
                <Table.Col></Table.Col>
              </Table.Row>
              <Table.Row>
                <Table.Col><b>Arribo a Cliente:</b></Table.Col>
                <Table.Col>{movlogs.arriboClienteLleno}</Table.Col>
                <Table.Col></Table.Col>
                <Table.Col></Table.Col>
              </Table.Row>
            </>
          )}

          {/* Campos específicos para importaciones */}
          {Movimiento.idMovimientoTipo.id === 2 && (
            <Table.Row>
              <Table.Col><b>Salida de dirección de entrega:</b></Table.Col>
              <Table.Col>{Movimiento.salidaClienteLleno}</Table.Col>
              <Table.Col><b>Ingreso a terminal:</b></Table.Col>
              <Table.Col>{Movimiento.arriboTerminalCargado}</Table.Col>
            </Table.Row>
          )}

          <Table.Row>
            <Table.Col><b>Tiempo total de ruta:</b> {tiempos.tiempoRuta} hrs</Table.Col>
            <Table.Col></Table.Col>
            <Table.Col><b>Estadía en cliente:</b> {tiempos.estadia} hrs</Table.Col>
            <Table.Col></Table.Col>
          </Table.Row>

          <Table.Row>
            <Table.Col><b>Distancia recorrida:</b></Table.Col>
            <Table.Col>
              {coordenadas.length > 1 ? 
                `${distanciaTotal.toFixed(2)} km` : 
                (distancia === 0 ? "No disponible" : `${(distancia/1000)} km`)}
            </Table.Col>
          </Table.Row>

          <Table.Row>
            <Table.Col><b>Detenciones calculadas:</b></Table.Col>
            <Table.Col>{detencionesCalculadas?.length || 0}</Table.Col>
          </Table.Row>

          <Table.Row>
            <Table.Col><b>Evidencia de colocación:</b></Table.Col>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  renderTablaDetenciones() {
    const { detencionesCalculadas } = this.state;
    
    if (!detencionesCalculadas || detencionesCalculadas.length === 0) {
      return null;
    }

    return (
      <>
        <h4 style={{ marginTop: "20px", marginBottom: "10px" }}>Detenciones de Ruta</h4>
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.ColHeader>No.</Table.ColHeader>
              <Table.ColHeader>Inicio (min)</Table.ColHeader>
              <Table.ColHeader>Fin (min)</Table.ColHeader>
              <Table.ColHeader>Duración (min)</Table.ColHeader>
              <Table.ColHeader>Ubicación</Table.ColHeader>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {detencionesCalculadas.map((detencion, index) => (
              <Table.Row key={index}>
                <Table.Col>{index + 1}</Table.Col>
                <Table.Col>{detencion.inicio.toFixed(2)}</Table.Col>
                <Table.Col>{detencion.fin.toFixed(2)}</Table.Col>
                <Table.Col>{detencion.duracion.toFixed(2)}</Table.Col>
                <Table.Col>
                  Lat: {detencion.latitud.toFixed(5)}, Lon: {detencion.longitud.toFixed(5)}
                </Table.Col>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </>
    );
  }

  renderTablaIncidencias() {
    const { incidencias } = this.state;
    
    if (!incidencias || incidencias.length === 0) {
      return null;
    }

    const incidenciasFiltradas = incidencias
    .filter(incidencia => ![2,3,7,8,9,67,35, 11, 12,13, 14,16,860].includes(incidencia.incidencia.incidenciaTipo.id))
      // .filter(incidencia => incidencia.incidencia.incidenciaTipo.id !== 7 && incidencia.incidencia.incidenciaTipo.id !== 11 && incidencia.incidencia.incidenciaTipo.id !== 14)
      .sort((a, b) => new Date(a.fechaCreado) - new Date(b.fechaCreado));

    if (incidenciasFiltradas.length === 0) {
      return null;
    }

    return (
      <>
        <h4 style={{ marginTop: "20px", marginBottom: "10px" }}>Incidencias</h4>
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.ColHeader>No.</Table.ColHeader>  
              <Table.ColHeader>Fecha</Table.ColHeader>
              <Table.ColHeader>Nombre</Table.ColHeader>
              <Table.ColHeader>Ubicación</Table.ColHeader>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {incidenciasFiltradas.map((incidencia, index) => (
              <Table.Row key={index}>
                <Table.Col>{index + 1}</Table.Col>
                <Table.Col>{new Date(incidencia.fechaCreado).toLocaleString()}</Table.Col>
                {/* <Table.Col>{incidencia.incidencia.incidenciaTipo.nombre || "Sin descripción"}</Table.Col> */}
                <Table.Col>{incidencia.incidencia.nombre || "Sin descripción"}</Table.Col>
                <Table.Col>
                  {incidencia.latitud && incidencia.longitud ? 
                    `Lat: ${incidencia.latitud.toFixed(5)}, Lon: ${incidencia.longitud.toFixed(5)}` : 
                    "No disponible"}
                </Table.Col>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </>
    );
  }

  renderMapaYEvidencia(coordenadas, avgLat, avgLon) {
    const { trackPoints, imagesMovGps } = this.state;

    return (
      <Table>
        <Table.Body>
          <br />
          <h4>Evidencia de colocación:</h4>
          
          {/* Primera fila para las imágenes */}
          <Table.Row>            
            {imagesMovGps && imagesMovGps.length > 0 && (
              <Table.Col>
                <div style={{ display: 'flex', flexWrap: 'wrap', maxWidth: '100%' }}>
                  {imagesMovGps.map((image, index) => (
                    <div 
                      key={index} 
                      style={{ 
                        width: '33%', 
                        padding: '5px',
                        marginBottom: (index + 1) % 3 === 0 ? '20px' : '0'
                      }}
                    >
                      <img
                        src={`data:image/png;base64,${image}`}
                        style={{
                          width: '100%',
                          height: '200px',
                          objectFit: 'contain',
                        }}
                        alt={`Evidencia ${index + 1}`}
                      />
                    </div>
                  ))}
                </div>
              </Table.Col>
            )}
          </Table.Row>
          
          {/* Segunda fila para el mapa */}
          <Table.Row>
            <Table.Col>
              <br />
              <h4>Mapa de ruta:</h4>
              {trackPoints && trackPoints.length > 0 && (
                <MapContainer
                  zoom={6}
                  style={{ height: "400px", width: "350px" }}
                  center={[avgLat, avgLon]}
                  whenReady={(map) => {
                    L.polyline(coordenadas).addTo(map.target);
                  }}
                >
                  <TileLayer url="http://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}" />
                </MapContainer>
              )}
            </Table.Col>      
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  renderFooter() {
    return (
      <div className="footer2">
        <h5 align="center">Río Danubio 87, Colonica Cuahutemoc, Delegación Cuahutémoc. C.P. 06500, Ciudad de México</h5>
        <h5 align="center">Skyangel México•EUA•Centroamérica</h5>
        <h5 align="center">52 76 76 70 | 01 800 750 54 63</h5>
      </div>
    );
  }

  render() {
    const { padre } = this.props;
    const { loading } = this.state;

    if (loading) {
      return <div>Cargando...</div>;
    }

    // Imprimir trackPoints antes de procesar
    console.log("trackPoints:", this.state.trackPoints);

    // Procesar datos
    const tiempos = this.calcularTiempos();
    const { coordenadas, avgLat, avgLon } = this.procesarCoordenadas();
    const distanciaTotal = this.calcularDistanciaTotal(coordenadas);

    // Calcular detenciones si hay coordenadas
    if (coordenadas.length > 1 && parseFloat(tiempos.tiempoRuta) > 0) {
      const tiempoEntrePulsos = ((parseFloat(tiempos.tiempoRuta) * 60) / (coordenadas.length - 1)).toFixed(2);
      const detencionesCalculadas = this.calcularDetenciones(coordenadas, parseFloat(tiempoEntrePulsos));
      
      if (this.state.tiempoEntrePulsos !== tiempoEntrePulsos || 
          JSON.stringify(this.state.detencionesCalculadas) !== JSON.stringify(detencionesCalculadas)) {
        this.setState({ 
          tiempoEntrePulsos: tiempoEntrePulsos,
          detencionesCalculadas: detencionesCalculadas
        });
      }
    }

    return (
      <div style={{ marginLeft: '52px', marginRight: '83px' }}>
        <Grid.Row>
          <div>
            <ReactToPrint
              trigger={() => <button>Generar PDF</button>}
              content={() => this.componentRef.current}
            />
            <div ref={this.componentRef}>
              {this.renderHeader()}
              <div>
                {this.renderInfoBasica()}
                {this.renderDetallesMovimiento(tiempos, coordenadas, distanciaTotal)}
                {this.renderTablaDetenciones()}
                {this.renderTablaIncidencias()}
                {this.renderMapaYEvidencia(coordenadas, avgLat, avgLon)}
              </div>
              {this.renderFooter()}
            </div>
          </div>
        </Grid.Row>
      </div>
    );
  }
}

export default BitacoraPdf;
